import { Button, Input, message, Modal, Popconfirm, Select } from 'antd';
import { Option } from 'antd/lib/mentions';
import { FC, useState } from 'react';
import baseuri from '../../../methods/baseuri';
// import SelectUserType from './SelectUserType';
interface ICreateNewAgent {
	userTypeList: any;
}
const CreateNewAgent: FC<ICreateNewAgent> = ({ userTypeList }) => {
	const [visible, setVisible] = useState(false);
	const [loading, setloading] = useState(false);
	const [userType1, setUserType1] = useState('');
	const [email, setEmail] = useState('');

	const handleCreate = async () => {
		try {
			setloading(true);
			const res: any = await baseuri.post(`admin/users/assign-usertype`, {
				email: email?.trim().toLowerCase(),
				usertype: userType1,
			});

			if (res.status === 200) {
				setVisible(false);
				setloading(false);
				message.success('Agent created Successfully');
			} else {
				setloading(false);
				message.info(res.data.message);
			}
		} catch (e: any) {
			setloading(false);
			message.error('something went wrong');
		}
	};
	return (
		<>
			<Button
				type="primary"
				shape="round"
				ghost
				onClick={() => setVisible(true)}
			>
				Create new Agent
			</Button>
			<Modal
				title="Create New Agent"
				visible={visible}
				footer={[
					<Popconfirm title="Are you sure?" onConfirm={handleCreate}>
						<Button
							loading={loading}
							type="primary"
							disabled={!(email && userType1)}
						>
							Create
						</Button>
					</Popconfirm>,
				]}
				onCancel={() => setVisible(false)}
			>
				<Input
					addonAfter={
						<Select
							placeholder="select usertype"
							onChange={(e) => {
								setUserType1(e);
							}}
						>
							{userTypeList?.map((n: any) => (
								<Option value={n?._id} key={n._id}>
									{n?.name}
								</Option>
							))}
						</Select>
					}
					defaultValue="...email"
					placeholder="input email"
					value={email}
					onChange={(e: any) => setEmail(e.target.value)}
				/>
				{/* <p>
					UserType Name :{' '}
					<Input
						placeholder="input UserType name"
						value={inputDetails?.name}
						onChange={(e: any) =>
							setInputDetails({ ...inputDetails, name: e.target.value })
						}
					/>
				</p> */}
			</Modal>
		</>
	);
};

export default CreateNewAgent;
